import script from "./targetView.vue?vue&type=script&setup=true&lang=js"
export * from "./targetView.vue?vue&type=script&setup=true&lang=js"

import "./targetView.vue?vue&type=style&index=0&id=7decd0c4&lang=scss"

const __exports__ = script;

export default __exports__